import styled, {css} from 'styled-components';

type IconButtonStyledProps = {
  $light?: boolean;
};

export const Button = styled.button<IconButtonStyledProps>`
  width: 40px;
  height: 40px;
  padding: 10px;
  border-radius: 50%;
  background: ${props => props.theme.colors.$p6};
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    opacity: 0.8;
  }

  ${props =>
    props.$light &&
    css`
      background: transparent;
      width: auto;
      height: auto;
    `}

  ${props =>
    props.disabled &&
    css`
      &,
      &:hover {
        opacity: 0.6;
        cursor: default;
      }
    `}
`;
